export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "無記錄",
    "notifications.rp_has_been_updated": "已更新團體生活科",
    "moduleTitle.files": "檔案",
    "label.coordinator": "協調員",
    "sidebar.translations_managment": "",
    "table.file": "檔案",
    "label.report_overview": "",
    "label.parent_agreement": "家長同意書",
    "parentalConsent.i_consent_to_and_understand_that": "6. 我同意並理解，參加者參與獎勵計劃活動時可能會被拍攝照片，在参加者同意及其家長同意後，這些照片可作宣傳推廣之用。",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. 我明白參加者必須遵守紀錄簿或網上紀錄簿(ORB)中包含的獎勵計劃要求，相關執行處的政策和行為標準(不時修訂)以及執行處支部有關應急計劃、活動評核及進行野外鍛鍊科的要求，同時明白如果參加者不遵守以上要求，執行處支部有權終止參加者參加獎勵計劃活動。",
    "table.end_date": "結束日期",
    "label.activation_date": "啟動日期",
    "label.report": "",
    "label.award_is_offline": "獎項是離線的",
    "label.pending_changes": "待更改...",
    "errors.min_nights_required": "最少需要 {nights} 晚",
    "label.country": "國家",
    "notifications.award_leader_has_been_returned": "已修改獎勵計劃領袖",
    "notifications.participant_has_been_updated": "已更新參加者",
    "label.phone_number": "電話號碼",
    "roles.aj_assessor": "野外鍛錬科評核員",
    "notifications.person_state_has_been_changed": "已修改個人狀態",
    "pageTitle.dashboard": "版面",
    "moduleTitle.global_payment_method": "全球付款方式",
    "label.organization_type": "機構類別",
    "button.account_settings": "設定賬戶",
    "notifications.contact_has_been_updated": "已更新聯絡方法",
    "participant.recover_password": "恢復密碼",
    "notifications.assessment_request_has_been_sent": "已發送評核申請",
    "button.unassign": "",
    "label.start_date": "開始日期",
    "label.assign_labels": "",
    "sidebar.participants": "參加者",
    "roles.coordinator": "執行處支部組長",
    "label.organization_contact": "機構聯絡人",
    "tabs.customization": "客制化",
    "sidebar.award_units": "獎勵計劃中心",
    "button.change_goal": "修改目標",
    "translationsManagement.selectProject": "translationsManagement.selectProject",
    "award.rp": "團體生活",
    "label.size": "大小",
    "label.bulk_action_results": "批量操作結果",
    "notifications.activity_has_been_approved": "已批核活動",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "重新發送評核申請",
    "notifications.template_has_been_removed": "範本已被刪除",
    "button.award_settings": "獎勵計劃設定",
    "pageTitle.payment": "付款",
    "tasks.return_award": "修改獎章",
    "label.link": "連結",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "我的地區辦公室－相關聯絡",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "科目批核",
    "table.logs": "日誌",
    "moduleTitle.remove_file": "刪除檔案?",
    "label.email_confirmed": "已確認電郵",
    "notifications.activity_has_been_returned": "已退回活動",
    "label.note": "備註",
    "button.show": "",
    "tabs.adventurous_journey": "野外鍛鍊科",
    "sidebar.my_todolist": "我的待辦事項清單",
    "label.here": "這裡",
    "organisation.change_award_mode": "修改獎章模式",
    "table.note_from_al": "獎勵計劃領袖的訊息",
    "label.gender": "性別",
    "moduleTitle.remove": "刪除？",
    "errors.must_be_less_than": "必須小於{limit}",
    "button.logout": "退出",
    "label.no_selected_participants": "沒有選擇參加者",
    "button.new_aj_event": "新的野外鍛鍊科活動",
    "label.employement_status": "就業狀態",
    "tabs.logs": "日誌",
    "tabs.contacts": "聯絡方法",
    "label.option": "選擇",
    "dashboard.charts": "表格",
    "notifications.rp_has_been_approved": "已批核團體生活科",
    "pageTitle.new_participant": "新的參加者",
    "notifications.award_leader_has_been_approved": "已批核獎勵計劃領袖",
    "moduleTitle.would_you_like_to_remove_leader_training": "你想刪除獎勵計劃領袖的訓練嗎？",
    "moduleTitle.update_configuration_value": "更新配置值",
    "table.description": "描述",
    "table.organization": "組織",
    "label.youtube": "YouTube視頻網站",
    "label.author": "作者",
    "table.suitable_for_award_level": "適合章級",
    "label.content_update": "請稍候。正在更新內容...",
    "notifications.new_question_has_been_added": "已增加新問題",
    "pageTitle.nao_awards": "獎勵計劃總辦事處－獎章",
    "table.last_name": "姓",
    "moduleTitle.adventurous_journey_detail": "旅程詳情",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "大量處理"},
    "label.project_location_type": "活動地點類別",
    "label.email_help_award_level": "",
    "label.date": "日期",
    "label.previous_completed_award_place": "地點",
    "button.show_more": "顯示更多",
    "label.wwc_number": "WWC 號",
    "button.filter": "篩選",
    "notifications.rp_has_been_returned": "已修改團體生活科",
    "pageTitle.residetial_project_assessor_report": "團體生活科－評核員報告",
    "label.generating": "生成中… ",
    "moduleTitle.finance_system_data": "財務系統資料",
    "notifications.adventurous_journey_state_has_been_changed": "已修改野外鍛鍊科狀態",
    "route.levels": "章級",
    "moduleTitle.activity_leader": "活動領袖",
    "tasks.approve_event": "批准活動",
    "tasks.reject_event": "拒絕活動",
    "table.region": "地區",
    "pageTitle.nao_award_leaders": "獎勵計劃總辦事處－獎勵計劃領袖",
    "errors.must_be_at_least": "最少 {min} 個字元",
    "table.title": "稱謂",
    "table.last_activity": "最後的活動",
    "tasks.delete_registration": "刪除註冊",
    "table.date_time": "當地時間",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. 獎勵計劃執行處承諾尊重你的私隱。此表格收集的個人資料的目的是參加獎勵計劃活動。參加者如未能提供此此資料，則無法參加獎勵計劃活動。（注意這不適用於未提供參與者資料）我們也可能會使用你的個人資料向你發送我們認為你可能感興趣的其他獎勵計劃活動的資訊。我們可能會將這些個人資料透露給協助我們運營和管理獎勵計劃的其他本地或國際組織和服務提供商。如果你想與我們聯絡或了解你的個人資料，請聯絡執行處。你也可以聯絡執行處，索取其私隱政策的副本。",
    "aj.practice_journey": "實習旅程",
    "notification.log_has_been_restored": "活動日誌已還原",
    "tabs.my_participants": "我的參加者",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "督導員",
    "moduleTitle.your_parental_consent": "你的家長同意書",
    "route.registration_participants": "註冊的參加者",
    "placeholder.start_typing": "開始輸入…",
    "tasks.approve_award": "批准獎章",
    "route.registrations": "註冊",
    "button.add_activity": "加入活動",
    "notifications.aj_event_has_been_created": "已建立野外鍛鍊科",
    "states.supervisor_approval": "評核員批核",
    "label.description": "描述",
    "button.leave_anyway": "離開",
    "tabs.registrations": "註冊",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "通知。已更新翻譯\n",
    "pageTitle.nao_registration": "獎勵計劃總辦事處－註冊",
    "pageTitle.mro_logs": "我的地區辦公室－日誌",
    "meta.page_not_found": "頁面不存在",
    "label.bulk_action_unsuccessful": "{count} 個項目失敗：",
    "global.days": "日子",
    "table.review": "檢閱",
    "table.as_assessor_for": "成為評核員",
    "roles.if_staff_statistical_user": "國際獎勵計劃基金會(IAF)統計用戶",
    "table.levels": "章級",
    "label.suitable_for_level": "適合章級",
    "pageTitle.leaders": "領袖",
    "moduleTitle.send_test_email": "發送測試郵件",
    "pageTitle.tasks_removed_registration": "刪除參加者註冊",
    "label.you_will_be_forced_to_login_again_after_change": "修改完成後你會被要求再次登入",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "科目批核",
    "pageTitle.payments": "付款",
    "global.nights": "晚上",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "選擇機構",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "上傳檔案",
    "label.migrated_contact_email": "已遷移的聯繫人電子郵件",
    "label.for_award_unit": "為執行處支部",
    "label.aj_template_note": "備註範本",
    "table.last_log_added": "最近一次加入之日誌",
    "button.view_participant": "來自參加者",
    "label.please_comment_on_the_participants": "請就參加者的進度/表現/承諾給予評語",
    "label.consent_already_given_login": "已經同意，請以你孩子的身份登錄",
    "participant.level_start_date": "{value} 開始日期",
    "sidebar.my_region_office": "我的地區辦公室",
    "states.section_signoff": "科目批核",
    "moduleTitle.assessor_details": "評核員詳情",
    "moduleTitle.adventurous_journey_settings": "野外鍛鍊科設定",
    "moduleTitle.note_from_al": "獎勵計劃領袖的訊息",
    "button.add_role": "增加角色",
    "table.run": "跑",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "應用程式操作指南 - 獎勵計劃領袖",
    "tabs.section_approval": "科目批核",
    "roles.award_verifier": "獎章核實者",
    "tabs.activity_approval": "活動批核",
    "logs.add_log": "新增日誌",
    "tabs.award": "獎章",
    "notifications.this_role_has_read_only_persmission": "此角色具有唯讀許可權",
    "table.no_filtered_results": "沒有結果",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "地點詳情",
    "label.optional": "（僅供選擇）",
    "errors.do_not_match": "不符合",
    "label.use_comma_for_multiple_entries": "使用逗號表示多個條目",
    "label.operating_authority": "執行處",
    "label.activity_section": "活動科目",
    "notifications.you_have_been_logged_out": "你已退出",
    "table.finished": "完成",
    "button.same_as_billing": "等同發票",
    "table.payment": "付款",
    "table.current_level": "當前的章級",
    "button.view_nao": "不獲批核",
    "table.email_confirmation": "確認電郵",
    "moduleTitle.shipping_address": "郵遞地址",
    "label.secondary_phone_type": "第二電話類型",
    "notifications.saved": "儲存",
    "pageTitle.all_participants": "所有參加者",
    "label.first_name": "名",
    "label.oa_price": "執行處價格",
    "table.award_mode": "獎章模式",
    "tabs.api_keys": "Api Keys",
    "award.award_detail": "獎章詳情",
    "tabs.user_management": "使用者管理",
    "tabs.all_events": "所有活動",
    "notifications.history_record_has_been_removed": "已刪除歷史記錄",
    "award.no_data": "沒有數據",
    "notifications.preparation_training_has_been_added": "已新增基本訓練",
    "label.message": "信息",
    "notifications.participant_info_updated": "已更新參加者資料",
    "roles.nao_staff": "總辦事處職員",
    "tabs.adventurous_journeys": "野外鍛鍊科",
    "label.gops": "",
    "route.upload": "上傳",
    "notifications.history_record_has_been_added": "已新增歷史紀錄",
    "notifications.history_record_has_been_updated": "已更新歷史記錄",
    "label.no_data": "沒有資料",
    "button.add_coordinator": "增加支部組長",
    "label.you_are_already_logged_as": "你已經登入為",
    "route.my_national_office": "我的總辦事處",
    "tabs.leaders": "領袖",
    "label.email_confirmation": "電郵確認",
    "table.registration_date": "註冊日期",
    "notifications.role_has_been_removed": "已刪除角色",
    "button.move": "移動",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "詳情",
    "table.award_unit": "執行處支部",
    "sidebar.settings": "設定",
    "dashboard.leader_state": "領袖－按照省份",
    "notifications.award_unit_has_been_approved": "已批核獎勵計劃中心",
    "states.awaiting_approval": "等待批核",
    "table.level": "章級",
    "table.action_requested": "待處理",
    "label.organisation_mode": "機構模式",
    "label.no_note": "沒有備註",
    "tabs.my_events": "我的活動",
    "notifications.participants_have_been_added": "已新增參加者",
    "tabs.registration_questions": "",
    "button.delete_registration": "刪除註冊",
    "notifications.parental_consent_link_has_been_sent": "已發送家長同意書",
    "moduleTitle.select_role_organization": "選擇身份或機構",
    "label.experience": "經驗",
    "translationsManagement.modal.title": "translationsManagement.modal.title\n",
    "table.ic": "獨立國家",
    "table.id": "身份證明",
    "label.notify_email_explanation": "參加者將獲電郵通知其評核申請未能發出，並須要更新正確之評核員資料。",
    "participant.would_you_like_to_remove": "你想刪除這個賬戶嗎？",
    "table.fields_included": "",
    "label.user_guide_web_leader": "網站使用指南 - 獎勵計劃領袖",
    "label.journey_type": "旅程類別",
    "button.setup": "設定",
    "tabs.my_national_office": "我的獎勵計劃總辦事處",
    "notifications.training_has_been_removed": "已刪除訓練",
    "label.nominated_and_identified_persons": "已提名及指定人士可以查看資料但不能編輯",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "你由於不活躍所以已登出",
    "states.award_leader_signoff": "獎勵計劃領袖批核",
    "table.award_signoff_attempts": "獎章批核嘗試",
    "sidebar.regions": "地區",
    "label.activity_deleted_note": "此活動已刪除。 你可以點擊下面的按鍵將其還原。",
    "table.total": "總共",
    "errors.a_problem_has_occured_during_processing": "處理期間發生問題，請參閱更多信息",
    "participant.participant_already_has_gold_award": "參加者已擁有金章",
    "pageTitle.mro": "我的地區辦公室",
    "notifications.authorization_code_has_expired": "批核碼已無效",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "野外鍛錬活動",
    "global.loading": "登入中",
    "label.gnipp": "GNIPP",
    "sidebar.registrations": "註冊",
    "label.any_string": "任何字元串",
    "contact.change_contact_status": "修改聯絡人的狀態",
    "tabs.registration": "註冊",
    "label.override_payment_note": "取消付款通知單",
    "notifications.section_has_been_signed_off": "已簽署科目",
    "label.payment_date": "付款日期",
    "button.approve": "批核",
    "moduleTitle.loggin_in": "登入",
    "label.website": "網站",
    "label.role": "角色",
    "table.assessor_report": "評核員報告",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "曾任評核員",
    "pageTitle.registrations": "註冊",
    "parentalConsent.this_form_must_be_completed": "此表格 <strong>必須</strong> 由家長或監護人為 <strong>18歲以下</strong>的參加者填寫。",
    "button.apply": "",
    "errors.include_at_least_one_number": "包括最少一個數字",
    "label.content_restore": "重新整理…",
    "logs.hour": "小時",
    "parentalConsent.i_have_read_and_understand": "7. 我已閱讀並理解獎勵計劃大綱(本表格第5頁)中規定的獎勵計劃各章級要求。",
    "notifications.award_was_deleted": "",
    "label.journey_category": "旅程類別",
    "notifications.search_cancelled": "搜尋被中斷，你需要等待搜尋完成。",
    "route.detail": "詳情",
    "route.user_guide": "使用指南",
    "moduleTitle.history": "歷史",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "未指派參加者",
    "states.inactive": "不活躍",
    "pageTitle.search_results": "搜尋結果",
    "button.proceed_to_login": "開始登入",
    "pageTitle.assessor_report_reject": "評核員報告修訂",
    "notifications.contact_has_been_removed": "已刪除聯絡方法",
    "sidebar.operating_authorities": "執行處",
    "label.no_note_from_participant": "參加者沒有提供備忘",
    "aj.preparation_and_training": "準備與訓練",
    "route.user_guide_web_leader": "網站使用指南 - 獎勵計劃領袖",
    "label.position_in_organization": "機構中的職位",
    "errors.emails_dont_match": "電子郵箱不一致",
    "route.my_participants": "我的參加者",
    "pageTitle.customisations": "定制服務",
    "tabs.localization_files": "本地化文件",
    "table.assessor_approval": "評審員批核",
    "tabs.related_contacts": "相關聯絡",
    "table.aus": "執行處支部",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "可能的值：",
    "label.if_your_download_doesnt_start": "如果你的下載沒有自動開始，請點擊此處",
    "route.independent_award_centres": "獨立執行處支部",
    "pageTitle.user_guide": "使用指南",
    "button.visit": "",
    "label.hours_first_letter": "h",
    "pageTitle.my_organization_detail": "我的機構 - 細節",
    "pageTitle.nao_detail": "獎勵計劃總辦事處－詳情",
    "button.change": "改變",
    "award.aj": "野外鍛錬",
    "table.award_state": "獎勵計劃狀態",
    "pageTitle.tasks_award_signoff": "獎章批核",
    "pageTitle.regions": "地區",
    "notifications.award_has_been_signed_off": "已簽署獎章",
    "dashboard.award_approved_by": "獎章批核－按照2016年章級",
    "tabs.new_template": "新的範本",
    "error.parent_email_must_be_filled": "必須填寫家長電子郵件",
    "label.organisation_invoicing_name": "許可證持有人名稱",
    "pageTitle.related_contacts": "相關聯絡",
    "button.try_again": "關閉警告然後重試",
    "label.cannot_be_change_to_another": "無法更改為其他章級",
    "notifications.lead_coordinator_has_been_set": "新的主要執行處支部組長已經設定",
    "label.training_name": "訓練名字",
    "moduleTitle.new_contact": "新的聯絡人",
    "translationsManagement.modal.updateTitle": "translationsManagement.modal.updateTitle\n",
    "moduleTitle.offline_award_units_signoff": "獎勵計劃領袖離線簽署",
    "notifications.award_level_has_been_changed": "已修改獎勵計劃章級",
    "label.subject": "主題",
    "route.silver_level": "銀章級",
    "label.privacy_notice": "",
    "label.switch_organization": "更換機構",
    "meta.dofe_name": "愛丁堡公爵國際獎勵計劃",
    "route.profile": "簡介",
    "roles.super_user": "超級用戶",
    "dashboard.while_you_were_gone": "在你離開的期間",
    "label.no_note_from_award_leader": "由獎勵計劃總辦事處退回",
    "label.middle_name": "中間名",
    "moduleTitle.new_activity": "新活動",
    "organisation.would_you_like_to_remove": "你想刪除這個機構嗎？",
    "label.state_province": "州／省／地區",
    "moduleTitle.your_home_address": "你的住址",
    "tabs.sign_offs": "批核",
    "moduleTitle.logs": "日誌",
    "button.view_more": "查看更多",
    "label.profile": "簡介",
    "label.title": "稱號",
    "tabs.award_signoff": "獎章批核",
    "label.post_code": "郵政編碼",
    "states.ceremony_certificate": "典禮",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. 我同意提供我的個人資料(包括參加者數據)給執行處和執行處支部。我同意我的個人資料會根據相關執行處的私隱政策(不時修訂)和《個人資料(私隱)條例》的規定，以及其他私隱法例、標準或指引來處理。",
    "label.user_guide_web_participant": "網站使用指南 - 參加者",
    "label.award_unit_type": "執行處支部類別",
    "states.complete": "",
    "table.participant_state": "參加者狀態",
    "pageTitle.my_organization_payment": "我的機構 - 付款",
    "table.approved": "批核",
    "pageTitle.my_organization_contacts": "我的機構－聯絡",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "改變為 <strong>{state}</strong>",
    "label.integer": "整數",
    "notifications.translationUpdateInterrupted": "通知。翻譯更新被影響。",
    "notifications.password_has_been_changed": "密碼已被修改",
    "button.invite_assessor": "邀請評核員",
    "label.other_activity": "其他活動",
    "notifications.parental_consent_has_been_sent": "已發送家長同意書",
    "button.revise": "修改",
    "errors.end_date_must_be_after_start_date": "結束日期必須晚於開始日期",
    "label.award_leader_signoff_date": "獎勵計劃領袖批核日期",
    "parentalConsent.i_understand_every_participant_must": "8. 我明白所有參加者都必須透過一個執行處支部參加獎勵計劃，該支部有權酌情接受或拒絕參加者及其建議的獎勵計劃活動。",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "野外鍛鍊科",
    "global.day": "日",
    "moduleTitle.coordinator": "執行處支部組長",
    "label.region": "地區",
    "button.add_history_record": "增加歷史紀錄",
    "moduleTitle.adventurous_journey_template_settings": "野外鍛鍊科範本設定",
    "notifications.personal_details_have_been_updated": "已更新個人資料",
    "sidebar.ics": "獨立國家",
    "table.independent_award_centre": "獨立執行處支部",
    "label.undelivered_mail_reason": "未成功發出電郵之原因",
    "table.utc_date_time": "UTC Time",
    "moduleTitle.emails": "電子郵件",
    "label.backoffice": "label.backoffice",
    "moduleTitle.parent_consent": "家長 / 監護人同意",
    "label.photo_consent_given": "參加者同意我們可以使用他/她的個人資料圖片作宣傳",
    "moduleTitle.authorising_contact": "授權聯絡人",
    "label.assessment_with_role": "{role} 評核",
    "dashboard.type_of_awards": "執行處支部類別",
    "moduleTitle.payment": "付款",
    "states.in_progress": "進展中",
    "logs.no_logs": "沒有日誌",
    "sidebar.my_office": "我的辦公室",
    "label.assessor_report": "評核員報告",
    "notifications.rp_has_been_signed_off": "已簽署團體生活科",
    "tabs.labels": "",
    "sidebar.payments": "付款",
    "meta.profile_questions": "簡介問題",
    "label.fax": "傳真",
    "label.email_help_custom_link": "",
    "label.last_name": "姓",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "參加者－按照章級",
    "tabs.award_leaders": "獎勵計劃領袖",
    "label.i_confirm_that_ive_witnessed": "我確認我已經親眼目睹以下活動的參加者日誌",
    "table.lead_coordinator": "主要執行處支部組長",
    "states.deleted": "刪除",
    "label.no_answers": "沒有答案",
    "button.add": "新增",
    "label.exchequer_number": "財務編號",
    "label.waiting": "等待",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "修改註冊",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "家長同意書",
    "table.assessor_approve": "評核員准許",
    "errors.some_fields_requires_your_attention": "有些欄位需要你的注意",
    "aj.qualifying_journey": "評核旅程",
    "route.awards": "獎章",
    "table.registration": "註冊",
    "pageTitle.assessors": "評核員",
    "notifications.award_has_been_updated": "已更新獎章",
    "errors.must_be_one_of": "必須是以下之一：{enums}",
    "pageTitle.logs": "日誌",
    "notifications.notifications.invitation_has_been_sent": "已發送邀請",
    "route.national_offices": "總辦事處",
    "notifications.training_has_been_updated": "已上傳訓練",
    "label.parent_last_name": "家長／監護人姓",
    "table.leaders": "領袖",
    "states.award_level_complete": "完成章級",
    "button.reset": "重新設定",
    "sidebar.my_award_unit": "我的執行處支部",
    "pageTitle.all_aj_events": "所有野外鍛鍊科活動",
    "label.activity": "活動",
    "moduleTitle.are_you_sure": "你確定嗎？",
    "route.gold_level": "金章級",
    "table.evidence": "證據",
    "label.delivery_confirmed": "確認送遞",
    "parentalConsent.as_the_parent": "作為父母 / 監護人，我同意國際獎勵計劃基金會使用所有照片作宣傳之用。",
    "label.awardMode.offline": "離線",
    "tasks.approve_registration": "批核註冊",
    "note.change_the_email_will_change": "注意：更改電子郵件也會更改已遷移聯絡人電子郵件",
    "notifications.participant_has_been_approved": "已批核參加者",
    "label.reached_activity_limit": "此科目活動已達到活動限制。參加者每個科目最多只可以進行3個活動。",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "已刪除基本訓練",
    "pageTitle.settings": "設定",
    "participant.level_registration_date": "{value} 註冊日期",
    "notifications.question_has_been_removed": "已刪除問題",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "獎勵計劃領袖",
    "notifications.participants_have_been_transferred": "已轉移參加者",
    "tabs.assessors": "評核員",
    "sidebar.dashboard": "版面",
    "pageTitle.independent_award_centers": "獨立執行處支部",
    "label.search": "搜尋",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "參加者備註",
    "errors.required_field": "必填欄位",
    "tasks.approve_task": "批准任務",
    "logs.edit_log": "編輯日誌",
    "table.state": "狀態",
    "moduleTitle.level_summary": "章級總結",
    "moduleTitle.guides": "",
    "modal.close": "關閉",
    "label.parent_first_name": "家長／監護人名",
    "parentalConsent.i_understand_that_the_participant": "1. 我明白參加者參加獎勵計劃之前必須填寫此表格(包括家長同意書)連同所需註冊費用交回相關獎勵計劃執行處/支部，才可獲執行處/支部接納。",
    "tabs.award_units": "執行處支部",
    "table.hours": "小時",
    "label.type": "類別",
    "notifications.adventurous_journey_has_been_removed": "野外鍛鍊科已被刪除",
    "label.aj_is_not_approved_yet": "野外鍛鍊科尚未獲批核",
    "roles.authorizing_contact": "授權聯絡人",
    "table.date_submitted_to_office_signoff": "提交給總辦事處批核的日期",
    "notifications.section_has_been_returned": "已退回科目",
    "table.created_by": "建立",
    "route.user_guide_web_participant": "網站使用指南 - 參加者",
    "route.templates": "範本",
    "states.awaiting_sign_off": "獎勵計劃領袖批核",
    "table.phone": "電話",
    "label.parental_consent": "家長同意書",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "銅章級",
    "label.invoice_currency": "發票貨幣",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "當前無法連接伺服器，請稍後再試。如果問題仍然存在，請聯繫我們的支援團隊。",
    "notifications.contact_has_been_created": "已建立聯絡方法",
    "pageTitle.profile_questions": "簡介問題",
    "table.observation_files": "觀察文件",
    "table.participants": "參加者",
    "tasks.no_evidence": "無證據提供",
    "button.edit": "編輯",
    "moduleTitle.leader": "領袖",
    "notifications.new_template_has_been_updated": "已更新新的範本",
    "table.name": "姓名",
    "label.no_results": "無結果",
    "moduleTitle.documents": "文件",
    "button.invite": "邀請",
    "label.goal": "目標",
    "pageTitle.nao_award_units": "獎勵計劃總辦事處－執行處支部",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "至少 {length} 個字元長",
    "label.email_help_note": "",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "刪除角色",
    "label.total": "總共",
    "label.delete_participant_award_info": "",
    "route.leaders": "領袖",
    "table.start_date": "開始日期",
    "moduleTitle.coordinators": "支部組長",
    "button.create": "創造",
    "tabs.awards": "獎章",
    "parentalConsent.form_has_been_sent": "已發送家長同意書",
    "states.journey_approval": "旅程批核",
    "pageTitle.reports": "報告",
    "table.journey_type": "旅程類別",
    "label.yes": "是",
    "pageTitle.assessor_report": "評核員報告",
    "label.organization": "機構",
    "notifications.award_leader_has_been_updated": "已更新獎勵計劃領袖",
    "moduleTitle.edit_role": "編輯身份",
    "table.journey_activity": "旅程活動",
    "label.location": "地點",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "野外鍛鍊科",
    "global.assessor": "評核員",
    "moduleTitle.profile_questions": "簡介問題",
    "activity.cannot_edit_activity_if_award_in_state": "如果獎勵計劃處於 {state} 狀態，則無法編輯活動",
    "moduleTitle.assessor_detail": "評核員詳情",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. 我明白執行處支部接受參加者加入獎勵計劃後，參加者會收到一本紀錄簿或得到網上紀錄簿(ORB)的訪問權限。在開始與獎勵計劃有關的活動之前，參加者應閱讀紀錄簿或ORB中有關獎勵計劃的要求。我明白執行處支部有權決定活動是否滿足獎勵計劃要求，因此可以決定是否頒發銅章、銀章或金章。我明白執行處支部可能會在接受參加者參與獎勵計劃後，為參加者提供有限的人身意外和公共責任保險，但是購買以及持續持有有效保險是參加者以及參加者家長的責任。",
    "notifications.award_has_been_returned": "已修改獎章",
    "label.code_of_conduct": "",
    "button.new_contact": "新的聯絡方法",
    "tabs.payments": "付款",
    "roles.naa_oa_staff": "獎勵計劃執行處工作人員",
    "label.switch_organisation_hint": "您可以隨時透過選擇右上角目錄中的\"切換機構\"來打開此對話框",
    "label.expiration_date": "失效日期",
    "tabs.participants": "參加者",
    "table.practice": "實習",
    "notifications.one_activity_has_to_remain": "科目中的一項活動必須保持活動狀態",
    "label.qualifications": "資歷",
    "states.organization_approval": "總辦事處批核",
    "errors.must_be_an_integer": "必須是整數",
    "participant.send_confirmation_email_again_question": "再次發送確認電郵？",
    "button.dismiss": "返回",
    "table.advice": "建議",
    "label.years_of_working_experience": "工作經驗年份",
    "notifications.search_failed": "搜尋時出現錯誤，請稍後再試。",
    "notifications.changes_have_been_saved": "所有修改已儲存",
    "moduleTitle.resend_parental_consent_link": "重新發送家長同意書連結？",
    "label.activity_type": "活動類別",
    "label.change_award": "更改獎勵計劃章級",
    "label.email": "電郵",
    "button.remove": "刪除",
    "button.download": "下載",
    "label.vat_treatment": "增值稅待遇",
    "pageTitle.aj_template_new": "新的野外鍛鍊科範本",
    "table.per_page": "每頁",
    "notifications.translations_has_been_updated": "通知。已更新翻譯\n",
    "notification.award_mode_has_been_updated": "已更新獎章模式",
    "tasks.revise_item": "修改項目",
    "button.resend_parental_consent": "重新發送家長同意書",
    "table.weeks_completed_required": "要求/完成的周數",
    "label.last_modified": "最後修改",
    "table.major": "主要活動",
    "label.vat_number": "增值稅號",
    "errors.passwords_dont_match": "密碼不一致",
    "table.country": "國家",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "已更新問題",
    "table.participant_name": "參加者姓名",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "授權碼不再有效",
    "errors.must_be_no_more_than": "最多不超過 {max} 字元",
    "notifications.event_has_been_rejected": "已修改活動",
    "tabs.customizations": "自訂",
    "label.name_organization": "名字",
    "button.add_log": "新增日誌",
    "moduleTitle.invite_assessor": "邀請評核員",
    "label.resend_confirmation_email": "重新發送確認信",
    "text.all_participants_will_be_transfered": "所有參加者將被轉移到新的獎勵計劃領袖",
    "label.repeat_email": "重複電子郵件",
    "errors.email_or_phone_required": "須填寫電郵或電話號碼",
    "notifications.role_has_been_updated": "角色已更新",
    "roles.if_staff_stat_user": "國際獎勵計劃基金會(IAF)統計用戶",
    "participant.delete_account": "刪除聯絡",
    "moduleTitle.would_you_like_to_remove_this_log": "你想刪除這日誌?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "旅程分類",
    "sidebar.manual_data_import": "手動數據導入",
    "label.created_after_date": "之後建立",
    "route.my_organization": "我的機構",
    "button.show_list": "",
    "label.leaders": "領袖",
    "notifications.log_has_been_modified": "已修改日誌",
    "button.upload_file": "上傳檔案",
    "moduleTitle.which_section_do_you_want_to": "你想那個科目返回到\"進行中\"？",
    "tabs.bronze_level": "銅章級",
    "notifications.participants_have_been_saved": "已儲存參與者",
    "pageTitle.aj_template_detail": "新的野外鍛鍊科",
    "label.parent_email": "家長／監護人 電郵",
    "map.appr_location": "大概地址：",
    "notifications.log_has_been_removed": "日誌已刪除",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "未成功發出之電郵",
    "button.stay": "繼續",
    "table.previous_level": "之前的章級",
    "label.award_start_date": "獎勵計劃開始日期",
    "assessor_report.returned_to_participant": "退回給參加者",
    "pageTitle.tasks_assessors_registration": "評核員註冊",
    "aj.cannot_modify_award": "如果參加者已分配野外鍛鍊活動，則不能更改章級。",
    "moduleTitle.lost_internet_connection": "網路連接已斷",
    "states.ceremony": "典禮",
    "participant.reactivate_account": "重啟賬戶",
    "label.birthdate": "出生日期",
    "pageTitle.assessment_send_successfully": "已成功發送評核報告",
    "states.assessor_approval": "評核員批核",
    "award.change_award_level": "修改章級",
    "label.url_no_longer_valid": "網址不再有效",
    "button.update": "更新",
    "label.secondary_email": "第二電子郵件",
    "button.role_edit": "編輯",
    "table.award_leader": "獎勵計劃領袖",
    "label.level": "章級",
    "tasks.evidence": "證據",
    "notifications.participant_is_already_in_list": "參加者已在名單中",
    "button.clear": "清除",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "設立",
    "table.activity": "活動",
    "label.copy_to_clipboard": "{text} 已複製於剪貼板中",
    "route.award_units": "執行處支部",
    "button.upload_photo": "上傳照片",
    "table.hours_completed_required": "完成的時間/要求的時間",
    "table.first_name": "名",
    "notifications.adventurous_journey_has_been_returned": "已修改野外鍛鍊科",
    "pageTitle.national_offices": "獎勵計劃總辦事處",
    "notifications.you_have_been_logged_in": "你已經登入",
    "logs.offline": "",
    "moduleTitle.add_role": "新增角色",
    "label.user_app_guide_participant": "應用程式操作指南 - 參加者",
    "notifications.file_has_been_removed": "文件已刪除",
    "label.send_message": "",
    "button.select": "選擇",
    "label.reason_of_deletion": "刪除的原因",
    "label.user_guide": "使用指南",
    "pageTitle.nao_participants": "獎勵計劃總辦事處－參加者",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "上載者",
    "tasks.approve_item": "批准項目",
    "tasks.restore_participant_registration": "恢復參加者註冊？",
    "label.awardMode.hybrid": "混合",
    "table.first_activity_started": "第一個開始的活動",
    "moduleTitle.dates": "日期",
    "table.no_results": "無結果",
    "states.registration_approval": "註冊批核",
    "table.breakdown_of_hours": "細分時間",
    "pageTitle.tasks_registration": "參加者註冊",
    "button.create_new": "建立新的",
    "sidebar.todolist": "待辦事項",
    "label.active_participants": "活躍參加者",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "修改任務",
    "organisation.change_organisation_state": "修改機構狀態",
    "moduleTitle.roles": "角色",
    "label.no_config_key_available": "此部分沒有可用的配置鍵",
    "placeholder.selectLanguage": "placeholder.selectLanguage",
    "states.office_signoff": "獎勵計劃總辦事處批核",
    "notifications.translations_has_been_updated.failure": "通知。已更新翻譯。錯誤",
    "logs.minute": "分鐘",
    "label.last_activity": "最後的活動",
    "sidebar.user_guide": "使用者指南",
    "label.trained_award_leader": "已接受訓練的獎勵計劃領袖",
    "table.progress": "進展",
    "table.suboperating_authorities": "執行處支部",
    "activity.cannot_edit_activity_offline": "",
    "label.user_does_not_have_permissions": "",
    "notifications.assessor_has_been_approved": "已確認評核員",
    "route.activity_approval": "活動批核",
    "moduleTitle.role": "角色",
    "button.run": "跑",
    "label.to": "到",
    "notifications.file_has_been_updated": "文件已更新",
    "moduleTitle.edit_coordinator": "編輯執行處支部組長",
    "notifications.authorization_code_is_no_longer_valid": "授權碼不再有效",
    "button.reject": "拒絕",
    "label.label.participant_status": "參加者狀態",
    "award.gold_level": "金章級",
    "sidebar.variables": "多樣的",
    "parentalConsent.checkbox_copy": "我確認我是 {firstName} {lastName} 的父母 / 監護人。我同意他 / 她在已受訓的獎勵計劃領袖監督下參加 {organisationName} 的香港青年獎勵計劃。我已閱讀，明白並同意上述及獎勵計劃網站所描述的參加要求與條件。",
    "button.go_to_dashboard": "前往版面",
    "button.add_option": "增加選項",
    "label.is_completed": "完成",
    "pageTitle.award_units": "獎勵計劃中心",
    "states.completed": "完成",
    "button.adventurous_journey_template_settings": "野外鍛鍊科範本設定",
    "label.system_rights": "系統權利",
    "label.assessor_assesstment_award_start_date": "label.assessor_assesstment_award_start_date",
    "label.update_translation_question": "",
    "button.login": "登入",
    "label.name_of_the_unit": "執行處支部名字",
    "button.send": "發送",
    "award.ajs": "野外鍛錬",
    "meta.payments_expired": "付款 - 無效",
    "label.age": "年齡",
    "notifications.payment_info_updated": "已更新付款資訊",
    "table.is_completed": "完成",
    "table.invited_by": "被邀請",
    "route.files": "檔案",
    "route.assessors": "評核員",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "我的參加者",
    "label.change_leader_status": "修改領袖狀態",
    "moduleTitle.parent_consent_form": "家長 / 監護人同意書",
    "notifications.authorization_contact_has_been_set": "已設定批核連絡人",
    "button.close": "關閉",
    "label.independent_country": "獨立國家",
    "notifications.aj_preparation_training_has_been_returned": "已修改野外鍛鍊科基本訓練",
    "route.history_log": "歷史日誌",
    "participant.account_settings": "設定賬戶",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} 因為",
    "label.orb_account": "網上紀錄簿帳戶",
    "notifications.file_url_is_not_specified_in_configuration": "未在配置中指定文件網址",
    "notifications.award_unit_has_been_removed": "已刪除執行處支部 / 獨立執行處支部",
    "table.parent": "家長",
    "label.mode_of_transport": "行進模式",
    "label.parental_consent_email_info": "不要忘記查看家長的電子郵件，並從獎勵詳情版面手動發送同意書。",
    "label.current_award": "目前獎章",
    "table.action": "行動",
    "pageTitle.suboperating_authorities": "執行處支部",
    "notifications.award_leader_has_been_assigned": "已指定獎勵計劃領袖",
    "tabs.sign_offs_locally": "當地批核",
    "Activity log has been restored": "通知。日誌_已_被_還原",
    "sidebar.naos": "獎勵計劃總辦事處",
    "tabs.aj_templates": "野外鍛鍊科範本",
    "notifications.logging_out": "正退出",
    "label.update_label": "",
    "button.organisation_settings": "機構設定",
    "tabs.independent_award_centers": "獨立執行處支部",
    "label.current": "當前",
    "table.location": "位置",
    "button.search": "搜索",
    "notifications.aj_preparation_training_has_been_approved": "已批核野外鍛鍊科基本訓練",
    "route.participants": "參加者",
    "label.other_location_information": "其他地點資訊",
    "label.number_of_records": "申請者人數",
    "translationsManagement.infoLabel": "translationsManagement.infoLabel\n",
    "parentalConsent.i_consent_to_pay_all": "5. 我同意支付參加者在參與獎勵計劃活動或往返活動期間出現的任何事故、傷害、疾病或損失而引致的費用，包括醫生，護士或醫院住宿和其他費用。",
    "label.nationality": "國籍",
    "states.approval": "批核",
    "notifications.something_went_wrong": "出了些問題",
    "aj.practice": "實習",
    "label.addressLine2": "地址第二行",
    "label.please_leave_a_note": "請留言",
    "placeholder.select": "選擇",
    "label.observations": "觀察",
    "label.aim": "目標",
    "label.addressLine1": "地址第一行",
    "roles.aj_instructor": "野外鍛鍊科導師",
    "meta.payments_waiting": "支付 - 等待",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "導師",
    "moduleTitle.remove_customization_and_reset": "刪除自訂並重設配置值？",
    "notifications.participant_registration_has_been_restored": "參與者註冊已經重新保存",
    "organisation.change_award_unit_mode": "修改機構模式",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "已刪除參加者",
    "label.language_settings": "語言設定",
    "notifications.event_has_been_approved": "已批核活動",
    "label.password": "密碼",
    "label.text": "文本",
    "table.observations": "觀察結果",
    "notifications.participant_has_been_created": "已建立參加者",
    "table.note_for_al": "獎勵計劃領袖的訊息",
    "label.payment_confirmed": "確認付款",
    "label.previous_completed_award_level": "之前的章級 (非ORB)",
    "pageTitle.new_aj_event": "新的野外鍛鍊科活動",
    "label.backend": " label.backend",
    "label.relationship_to_participant": "與參加者的關係",
    "award.physical_recreation": "康樂體育",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "評核員報告被拒",
    "label.supervisor_report": "督導者報告",
    "table.role": "角色",
    "route.user_guide_web_nao": "網站使用指南 - 獎勵計劃總辦事處",
    "label.page_not_found": "404 - 頁面不存在",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "文件已上傳",
    "moduleTitle.address": "地址",
    "moduleTitle.lead_coordinator": "主要執行處支部組長",
    "pageTitle.login": "登入",
    "label.frontoffice": " label.frontoffice",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "已建立團體生活科",
    "moduleTitle.award_unit": "執行處支部",
    "button.remove_file": "移除檔案",
    "moduleTitle.billing_address": "賬單地址",
    "pageTitle.my_aj_events": "我的野外鍛鍊科活動",
    "route.tasks": "任務",
    "button.confirm": "確認",
    "label.national_award_authority": "國家獎勵計劃行機構",
    "label.independent_award_centre": "獨立執行處支部",
    "award.generate_award_report": "建立報告",
    "route.my_region_office_customization": "我的地區辦公室 - 定制",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "已發送密碼修改要求",
    "tabs.detail": "詳情",
    "participant.change_participant_status": "改變參加者狀態",
    "table.key": "鍵",
    "label.find_address": "找到地址",
    "notifications.assessor_has_been_rejected": "已修訂評核員",
    "label.transfer_participants": "轉移參加者",
    "button.continue_to_payment_gateway": "繼續前往付款連結",
    "notifications.participant_registration_has_been_removed": "已刪除參加者註冊",
    "moduleTitle.page_not_found": "404 - 頁面不存在",
    "route.adventurous_journeys": "野外鍛鍊科",
    "states.registration_assessment": "註冊評核",
    "heading.change_award_unit_mode": "修改執行處支部模式",
    "label.user_guide_web_nao": "網站使用指南 - 獎勵計劃總辦事處",
    "tabs.silver_level": "銀章級",
    "table.paid_by": "已付款",
    "label.your_report_has_been_successfully_sent": "你的報告已經成功遞交",
    "sidebar.my_organization": "我的機構",
    "pageTitle.participants": "參加者",
    "notifications.preparation_training_has_been_updated": "已更新基本訓練",
    "moduleTitle.server_is_unreachable": "伺服器無法連接",
    "label.last_activity_date": "最近一次活動日期",
    "award.bronze_level": "銅章級",
    "moduleTitle.award_units": "執行處支部",
    "table.completed": "完成",
    "moduleTitle.revise_message": "修改訊息",
    "table.lastUsed": "最後使用",
    "award.bronze_to_gold_level": "銅章級至金章級",
    "button.change_password": "修改密碼",
    "label.nao_price": "國立獎勵計劃執行機構價格",
    "label.payment_state": "付款狀態",
    "label.wwc_expired": "WWC 過期",
    "label.award_office_signoff_date": "獎勵計劃總辦事處批核日期",
    "label.award_unit": "執行處支部",
    "award.gold_level_short": "金",
    "moduleTitle.other_info": "其他資訊",
    "table.note": "備註",
    "label.search_by_email_first_or_last": "以電郵、姓或名搜索",
    "tabs.history": "歷史",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "未獲分配的參加者",
    "table.main_award_leader": "執行處支部組長",
    "parentalConsent.i_as_the_parent": "3. 本人明白某些活動可能存在高風險，並且獎勵計劃執行處的保險安排可能不會涵蓋高風險的活動。我明白參加者參加獎勵計劃而產生的所有風險責任完全由參加者承擔。",
    "label.state": "狀態",
    "notifications.award_leader_has_been_removed": "已刪除獎勵計劃領袖",
    "tabs.organization_detail": "機構詳情",
    "table.operating_authorities": "執行處",
    "label.available_labels": "",
    "modal.select": "選擇",
    "tabs.expired_payments": "付款已過期",
    "moduleTitle.note_for_al": "獎勵計劃領袖的訊息",
    "moduleTitle.confirm": "確認",
    "notification.new_activity_added": "已增加新活動",
    "notifications.award_leader_has_been_moved": "已改動獎勵計劃領袖",
    "label.award_mode": "獎章模式",
    "label.phone": "電話",
    "notifications.organization_has_been_updated": "已更新機構",
    "moduleTitle.assessor": "評核員",
    "label.bulk_action_confirmation": "確認批量動作",
    "table.parent_approval": "家長批核",
    "label.date_of_delivery": "收件日期",
    "sidebar.assessors": "評核員",
    "label.journey_activity": "旅程活動",
    "award.inactive_award": "停止獎勵計劃",
    "label.end_date": "結束日期",
    "label.orb_testing": "網上紀錄簿測試",
    "label.no_activities": "沒有活動",
    "moduleTitle.please_confirm": "請確認",
    "button.login_with_another_account": "使用其他賬戶登入",
    "tasks.reject_registration": "修改註冊",
    "label.submitted_after_date": "之後提交",
    "label.update_translations_successful": "",
    "button.assign_leader": "分配領袖",
    "table.already_running": "已經開展",
    "label.no": "不是",
    "label.count_items_selected": "已選擇 {count} 個項目",
    "label.secondary_phone_number": "第二電話號碼",
    "label.my_experience": "我的經驗",
    "notifications.adventurous_journey_has_been_approved": "已批核野外鍛鍊科",
    "pageTitle.mro_detail": "我的地區辦公室－詳情",
    "moduleTitle.nao_specific_info": "獎勵計劃總辦事處具體資訊",
    "label.preparing_document_for_import": "準備要導入的檔案",
    "tasks.observations": "觀察所得",
    "notifications.confirmation_email_has_been_sent": "已發送確認電郵",
    "button.restore": "重新儲存",
    "label.importing_file": "檔案導入中",
    "label.or_dont_agree": "或者不同意？ 你能",
    "moduleTitle.award_leader": "獎勵計劃領袖",
    "label.me": "(我)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "輸出表格",
    "organisation.move_award_unit": "移動執行處支部",
    "label.file_category": "",
    "notifications.connecting_to_server": "連接到伺服器...",
    "parentalConsent.i_understand_that_a_and_b": "11. 我明白：<br /> 1. 除非參加者持有適當且有效的駕駛執照，並且有適當的第三者保險可承保因參加者駕駛而受傷的人，否則不得駕駛汽車或運輸參加獎勵計劃活動的其他參加者；和 <br /> 2. 參加者不可以乘搭任何與獎勵計劃無關或並非協助獎勵計劃運作的人士所駕駛的車輛，除非該人持有適當且有效的駕駛執照，並且有適當的第三者保險可承保因該人駕駛而受傷的人。",
    "table.reason": "原因",
    "pageTitle.contacts": "聯絡",
    "states.award_leader_approval": "獎勵計劃領袖批核",
    "meta.payments": "付款",
    "label.suboperating_authority": "執行處支部",
    "route.my_region_office": "我的地區辦公室",
    "states.registration_not_approved": "註冊不獲批核",
    "label.direct_entrant": "直接參加者",
    "tabs.all_participants": "所有參與者",
    "tabs.payment": "付款",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "重複新密碼",
    "label.other_roles": "網上紀錄簿用戶簡介頁面",
    "logs.hours": "小時",
    "notifications.spreadsheet_has_been_imported_successfully": "已成功導入試算表",
    "label.bulk_action_question": "對 {count} 個項目執行批量操作？",
    "moduleTitle.personal_details": "個人資料",
    "label.bulk_action_emailing": "",
    "route.my_events": "我的活動",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "包括最少大小寫字元各一個",
    "tabs.removed_participant_registrations": "刪除參加者註冊",
    "sidebar.mynao": "我的獎勵計劃總辦事處",
    "tabs.office_details": "辦公室詳情",
    "label.major": "主要的",
    "tabs.documents": "文件",
    "label.new_password": "新密碼",
    "sidebar.adventure_journey": "野外鍛鍊科",
    "pageTitle.customizations": "自訂",
    "moduleTitle.assessor_report": "{role} 報告",
    "label.registration_date": "註冊日期",
    "notifications.training_has_been_added": "已新增訓練",
    "aj.qualifying": "評核",
    "moduleTitle.you_have_been_logged_out_session_terminated": "你已登出，因為這環節已被終止",
    "award.service": "服務",
    "notifications.rp_state_has_been_changed": "已改變團體生活科狀態",
    "label.ctest_access": "使用測試平台",
    "table.created": "建立",
    "tasks.revise_task": "修改任務",
    "button.assign": "分配",
    "button.return": "退回",
    "table.status": "狀態",
    "button.restore_activity": "恢復活動",
    "tabs.new_aj_event": "新的野外鍛鍊科活動",
    "roles.if_staff_viewer": "國際獎勵計劃基金會(IAF)職員查看者",
    "notifications.new_template_has_been_created": "已建立新的範本",
    "global.something_went_wrong": "有錯誤",
    "table.expire_day": "失效日期",
    "tabs.history_log": "歷史紀錄",
    "label.form_of_payment": "付款表格",
    "button.add_training": "新增訓練",
    "label.par_reg_cust_note": "此選項卡允許您自訂參與者註冊中顯示的欄位，並影響您收集的資料量。如果您希望進行更改，請聯繫您的地區辦事處 - 只有愛丁堡公爵國際獎基金會系統管理員有權進行這些更改。",
    "label.my_qualification": "我的資歷",
    "button.add_new_profile_question": "增加新的簡介問題",
    "table.operating_authority": "執行處",
    "table.aim": "目的",
    "table.awards": "獎章",
    "participant.deactivate_account": "關閉賬戶",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "日期",
    "tasks.would_you_like_to_delete": "你想刪除這個參加者嗎？",
    "notifications.configuration_value_has_been_updated": "配置值已更新",
    "ajTemplates.fill_from_template": "填寫範本",
    "contact.send_test_email": "發送測試郵件",
    "moduleTitle.aj_preparation_and_training": "野外鍛鍊科基本訓練",
    "label.ce_be": "",
    "button.notify_participant": "交還參加者",
    "label.parent_phone": "家長／監護人 電話號碼",
    "label.nao_regulations": "",
    "award.skills": "技能",
    "label.reject_application": "拒絕這個申請",
    "leader.delete_account": "刪除連絡人",
    "table.assign": "分配",
    "roles.aj_supervisor": "野外鍛錬科督導員",
    "label.logout": "退出",
    "moduleTitle.award_leader_edit": "編輯獎勵計劃領袖",
    "moduleTitle.training": "訓練",
    "notifications.coordinator_has_been_removed": "已刪除支部組長",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "執行處支部組長",
    "label.bulk_action_successful": "已成功修改 {count} 個項目。",
    "tasks.clear_email_revision": "清除電郵修訂",
    "table.preparation": "準備",
    "table.delete": "刪除",
    "label.safeguarding_policy": "",
    "sidebar.reports": "報告",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "參加者於其他章級已擁有主要項目。你確認要新增主要項目嗎？",
    "pageTitle.operating_authorities": "執行處",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "確認",
    "notifications.invitation_has_been_sent": "已發送邀請",
    "pageTitle.independent_countries": "獨立國家",
    "label.assessors_email": "評核員電郵",
    "tasks.approve_assessor_registration": "確認評核員註冊",
    "table.award_duration": "獎章持續時間",
    "notifications.organization_has_been_moved": "已移動機構",
    "pageTitle.nao_payment": "獎勵計劃總辦事處－付款",
    "participant.history_log": "歷史紀錄",
    "label.rejected_with_note": "",
    "label.already_running": "已經推行",
    "button.continue": "點擊.繼續",
    "award.no_data_to_show": "沒有數據顯示",
    "participant.send_email_invitation_again_question": "再次發送電郵邀請？",
    "label.reason_for_changing_assessor": "更換評核員的原因",
    "button.delete": "刪除",
    "moduleTitle.requirements_and_conditions": "要求與條件",
    "roles.leader": "領袖",
    "label.if_download_doesnt": "如果下載沒有自動開始，請檢查瀏覽器中的彈出設定",
    "dashboard.your_todo_list": "你的待辦事項",
    "notifications.award_unit_has_been_returned": "已修改獎勵計劃中心",
    "moduleTitle.participant_activities": "參加者活動",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "活躍領袖",
    "aj.preparation": "準備",
    "button.change_state": "修改狀態",
    "label.current_password": "目前密碼",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "設定聯絡方法",
    "button.remove_photo": "刪除照片",
    "notifications.activity_has_been_setup": "已建立活動",
    "errors.must_be_more_than": "必須超過 {limit}",
    "table.goal": "目標",
    "notifications.coordinator_has_been_set": "已設定執行處支部組長",
    "label.cc": "抄送",
    "label.duration": "持續時間",
    "table.actions": "操作",
    "participant.send_email_invitation_again": "再次發送電郵邀請？",
    "moduleTitle.would_you_like_to_remove_participant": "你想刪除參加者嗎？",
    "parentalConsent.i_authorise_employees": "4. 如果參加者在參加活動中、旅途中或其他獎勵計劃相關的活動過程中遇到意外、受傷或生病，我授權執行處/支部的員工、管理人員或任何參與或協助組織獎勵計劃活動的其他人，可以為參加者獲取必要的醫療救助或治療，包括但不僅限於聘用醫生、護士或醫院住宿。",
    "button.reload_page": "重新載入頁面",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "電郵",
    "label.new_goal": "新的目標",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "無效的電郵地址",
    "pageTitle.new_contact": "新的聯絡",
    "sidebar.gops": "",
    "button.manage_participants": "管理參加者",
    "errors.invalid_phone_format": "無效的電話號碼",
    "notifications.login_details_have_been_changed": "已修改登入細節",
    "moduleTitle.participant_logs": "參加者日誌",
    "label.save": "儲存",
    "label.frequently_asked_questions": "常見問題",
    "label.city": "城市",
    "notifications.configuration_value_has_been_reset": "配置值已重設",
    "states.office_sign_off": "總辦事處批核",
    "button.save": "儲存",
    "button.import_data_from_selected_file": "從所選檔案導入數據",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. 我明白參加者不能開始任何活動，除非我滿意參加者提名的義工(非執行處支部僱員)具有適當的經驗和/或有資格指導/督導/評核該獎勵計劃科目，而且所有相關義工已完成並將所需的文件提交給執行處支部。",
    "pageTitle.apiKeys": "Api Keys",
    "label.international_region": "國際地區",
    "tabs.levels": "章級",
    "tabs.additional_files": "其它檔案",
    "label.continuation_level": "漸進參加章級",
    "table.adventurous_journey_detail": "野外鍛鍊科詳情",
    "button.set": "設定",
    "label.i_certify_that_as_the_assessor": "我確認作為此活動的 {role}，該參加者已滿足所有要求。",
    "table.coordinator": "支部組長",
    "participant.send_confirmation_email_again": "再次發送確認電郵？",
    "table.report": "報告",
    "label.update_translations_results": "",
    "table.observation_note": "觀察筆記",
    "label.view_more": "查看更多",
    "notifications.payment_link_has_been_reset": "付款連結已經重新設定",
    "table.type": "類別",
    "moduleTitle.updateConfigurationKey": "更新配置密匙",
    "sidebar.independent_award_centers": "獨立執行處支部",
    "table.activity_type": "活動類別",
    "label.awardMode.online": "網上",
    "table.data_state": "最後刷新日期",
    "button.generate_report": "建立報告",
    "moduleTitle.assessed_by_award_leader": "獎勵計劃領袖評核",
    "table.child_protection_number": "兒童保護號碼",
    "button.bulk_change": "批量修改",
    "label.send_welcome_email": "",
    "label.award_state": "獎章狀況",
    "moduleTitle.overview": "概述",
    "table.aj_detail": "野外鍛鍊科詳情",
    "pageTitle.tasks_activity_approvals": "活動批核",
    "label.section": "科目",
    "route.history": "歷史",
    "route.event_participants": "活動參加者",
    "participant.account_detail": "設定賬戶",
    "route.dashboard": "版面",
    "table.payments": "付款",
    "pageTitle.profile": "簡介",
    "organisation.remove_organisation": "刪除機構",
    "pageTitle.my_organization": "我的機構",
    "label.award_leader": "獎勵計劃領袖",
    "notifications.assessor_has_been_updated": "已更新評核員",
    "label.participant_personal_reflection": "",
    "button.add_key": "增加鍵",
    "header.appMotto": "公爵",
    "table.qualifying": "評核",
    "button.upload": "上傳",
    "button.resend": "重新發送",
    "label.filename": "檔案名",
    "label.change_parental_consent": "",
    "button.cancel": "取消",
    "label.aply_to_all_langs": "",
    "route.customization": "客制化",
    "errors.minimal_duration_is": "最少持續時間是30分鐘",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "參加者狀態",
    "award.bronze_level_short": "銅",
    "label.phone_type": "電話號碼類別",
    "global.night": "晚上",
    "button.adventurous_journey_settings": "野外鍛鍊科設定",
    "participant.leader_must_be_selected": "必須選擇領袖",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "用戶增加基本訓練",
    "table.approve": "批准",
    "label.role_in_organisation": "機構中的角色",
    "states.finished": "完成",
    "label.created": "建立",
    "button.back_to_home": "返回",
    "label.options": "選擇",
    "contact.next_level_invitation": "下一個章級的邀請",
    "moduleTitle.activity_detail": "活動詳情",
    "route.section_signoff": "科目批核",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "設定聯絡方法",
    "label.transation_id": "交易編號",
    "notifications.activity_has_been_updated": "已更新活動",
    "sidebar.awards": "獎項",
    "parentalConsent.images_consent": "作為家長/監護人，我同意基金會使用任何照片用作宣傳。",
    "participant.would_you_like_to_delete": "你想刪除這個賬戶嗎？",
    "roles.user": "統計",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "無結果",
    "moduleTitle.address_line_2": "地址第二行",
    "states.awaiting_office_sign_off": "總辦事處批核",
    "moduleTitle.export": "輸出",
    "moduleTitle.address_line_1": "地址第一行",
    "notifications.participant_has_been_assigned": "已分配參加者",
    "roles.viewer": "觀察者",
    "label.participants_total": "參加者總數",
    "errors.auth_code_is_no_longer_valid": "批核碼不再有效 - 它可能已被使用或已過期",
    "label.file_is_not_available": "檔案不可用",
    "button.select_template": "選擇範本",
    "label.payment": "付款",
    "award.silver_level_short": "銀",
    "table.participant_id": "參加者編號",
    "text.hours_old": "已有{hours}小時",
    "moduleTitle.your_personal_information": "你的個人資料",
    "aj.minimum_date_recommendation": "野外鍛鍊科實習旅程和 {name} 的最少建議日期為",
    "label.date_of_payment": "付款日期",
    "button.view": "觀看",
    "label.create_new_label": "",
    "title.confirmation": "確認",
    "button.set_participants": "參與者設定",
    "roles.assessor": "評核員",
    "moduleTitle.coordinator_settings": "執行處支部組長設定",
    "label.parent_relationship": "家長關係",
    "table.nao": "香港青年獎勵計劃",
    "notifications.email_has_been_sent": "已發送電郵",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "執行處支部",
    "route.award": "獎章",
    "label.no_roles": "沒有角色",
    "table.files": "文件",
    "aj.minimum_date_requirements": "評核旅程的最少日數和{name}是",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "參加者離線",
    "moduleTitle.other_coordinators": "其他執行處支部組長",
    "button.updateSelectedLanguage": "button.updateSelectedLanguage",
    "tasks.approve_award_registration": "批准獎章註冊",
    "participant.invite_participant_to_next_level": "邀請參加者進入下一個章級？",
    "label.twitter": "Twitter",
    "pageTitle.awards": "獎章",
    "warning.award_marked_as_paid": "",
    "table.edit": "編輯",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "國際青年獎勵計劃",
    "moduleTitle.after_assigning_a_role_to_yourself": "為自己分配或更改角色後，你需要再次登入。",
    "label.transaction_id": "交易編號",
    "table.suboperating_authority": "執行處支部",
    "label.participant_survey": "邀請參加者參與基金會的網上調查",
    "label.created_by": "被建立",
    "button.send_confirmation_email_again_question": "再次發送確認電郵",
    "label.email_help_award_leader_email": "",
    "label.name": "姓名",
    "tabs.gold_level": "金章級",
    "pageTitle.award_documents": "獎勵計劃文件",
    "label.online_payments": "網上付款",
    "label.child_protection_number": "兒童保護號碼",
    "participant.send_password_recovery_email": "發送恢復密碼電郵件？",
    "notifications.new_log_has_been_added": "已新增日誌",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "機構名稱",
    "pageTitle.my_organization_templates": "我的機構－範本",
    "pageTitle.award_leaders": "獎勵計劃領袖",
    "label.status": "狀態",
    "label.street": "街道",
    "roles.if_staff_superuser": "國際獎勵計劃基金會(IAF)職員超級用戶",
    "table.licence_holder": "執照持有人",
    "label.created_at": "建立於",
    "table.section": "科目",
    "table.system_rights": "系統權限",
    "label.iac_type": "獨立執行處支部類型",
    "label.other": "其他",
    "moduleTitle.login": "登入",
    "label.no_data_to_show": "沒有資料顯示",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "如果參加者已指定野外鍛鍊科，則無法修改獎勵計劃章級。",
    "tabs.waiting_payments": "等待付款",
    "global.supervisor": "督導員",
    "notifications.new_role_has_been_added": "己加入新的角色",
    "award.silver_level": "銀章級",
    "heading.change_awards_mode": "修改獎章模式",
    "button.save_changes": "儲存修改",
    "organisation.would_you_like_to_move_award_unit": "你想把這個機構移動到哪裡？",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "我的地區辦公室－詳情",
    "table.started_at": "開始",
    "parentalConsent.i_consent_to_the_award_unit": "2. 本人同意執行處/支部及參與或協助組織獎勵計劃活動的任何其他個人，包括義工*及司機，如有需要可運送參加者以參加與獎勵計劃有關的活動。我明白執行處/支部會提前通知我何時何地運送參加者。",
    "logs.minutes": "分鐘",
    "label.total_participants": "總參加者",
    "moduleTitle.contact_info": "聯絡資料",
    "table.payment_link": "付款連結",
    "errors.please_contact_your_local_award_staff": "請聯絡當地獎勵計劃工作人員"
}